import React from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { withRouter } from "react-router-dom";

// users
import user from "../../../images/user-icon.png";
import { useOktaAuth } from "@okta/okta-react";

const ProfileMenu = (props) => {
  const [menu, setMenu] = React.useState(false);
  const toggle = () => setMenu(!menu);

  const { oktaAuth } = useOktaAuth();

  const logout = async () => {
    sessionStorage.setItem("user", null);
    await oktaAuth.signOut();
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={toggle}
        className="notification-list list-inline-item nav-pro-img"
        tag="li"
      >
        <DropdownToggle className="nav-link arrow-none nav-user" tag="a">
          <img src={user} alt="user" className="rounded-circle" />
        </DropdownToggle>
        <DropdownMenu className="profile-dropdown" right>
          <DropdownItem tag="button" className="text-danger" onClick={logout}>
            <i className="mdi mdi-power text-danger"></i> Logout
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withRouter(ProfileMenu);
